exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".lider-rango-tooltip{max-width:340px!important}.lider-rango-tooltip .tooltip-inner{background:#0f0f0f;text-align:left;padding:10px 12px;border-radius:10px}.lider-rango-tooltip .tooltip-arrow{border-color:#0f0f0f}.lider-rango-tooltip .lrtt-condicion{font-weight:700;font-size:12.5px;color:#fff;margin-bottom:6px}.lider-rango-tooltip .lrtt-def{font-size:11.5px;line-height:1.4;color:hsla(0,0%,100%,.9);white-space:normal}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-06f4baad","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/lideres/ResultLider.vue
// module id = 1273
// module chunks = 2